
import React from "react";
import { Label } from "@/components/ui/label";
import { Calendar } from "lucide-react";
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from "@/components/ui/select";
import { format, endOfMonth } from "date-fns";
import { es } from "date-fns/locale";

interface MonthSelectorProps {
  selectedMonth: string;
  setSelectedMonth: (month: string) => void;
}

export const MonthSelector = ({ selectedMonth, setSelectedMonth }: MonthSelectorProps) => {
  // Get month options for the last 12 months
  const getMonthOptions = () => {
    const options = [];
    const currentDate = new Date();
    
    for (let i = 0; i < 12; i++) {
      const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
      options.push({
        value: format(date, "yyyy-MM"),
        label: format(date, "MMMM yyyy", { locale: es })
      });
    }
    
    return options;
  };

  // Get last day of selected month
  const getLastDayOfMonth = (yearMonth: string) => {
    const [year, month] = yearMonth.split("-").map(Number);
    return endOfMonth(new Date(year, month - 1));
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="month" className="flex items-center gap-1">
        <Calendar className="h-4 w-4" />
        <span>Seleccionar Mes</span>
      </Label>
      <Select value={selectedMonth} onValueChange={setSelectedMonth}>
        <SelectTrigger id="month" className="bg-white">
          <SelectValue placeholder="Seleccione mes" />
        </SelectTrigger>
        <SelectContent className="bg-white">
          {getMonthOptions().map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-xs text-muted-foreground">
        Fecha seleccionada: {format(getLastDayOfMonth(selectedMonth), "dd/MM/yyyy", { locale: es })}
      </p>
    </div>
  );
};
